/**
 * Frontend-only prompt wrapper so template projects stay in incremental-edit mode.
 * Augments the user message stored/sent to the API; backend uses DB file count for mode.
 */
export function buildTemplateEditPrompt(userInput, templateMeta) {
  if (!templateMeta?.type || !userInput?.trim()) return userInput;

  const name = templateMeta.name || 'Template';
  return [
    '[TEMPLATE PROJECT — INCREMENTAL EDIT ONLY]',
    `Starter template "${name}" is already loaded in this workspace.`,
    'Rules: modify and extend existing files only; preserve component structure, sections, layouts, and styles;',
    'do NOT regenerate the entire project from scratch; do NOT overwrite unrelated files; do NOT delete template architecture.',
    '',
    `User request: ${userInput.trim()}`,
  ].join('\n');
}

export function isTemplateIncrementalMode(templateMeta, hasProjectFiles) {
  return !!(templateMeta?.type && hasProjectFiles);
}
